import React, { Component } from 'react';
import {firestore} from '../firebase'
export default class TestPage extends Component {

    componentDidMount() {
        console.log("MOUNTING");

        firestore.collection("users")
            .where("teamId", "==", "webzites-nl")
            .get().then(result => {
            console.log(result);
            result.forEach(obj => {
                console.log("DATA:", obj.data());
            });
            // console.log(result);
        });

    }

    render() {

        return (
            <div className="card">
                <div className="card-heading">
                    <h1 className="card-title">
                        Test
                    </h1>
                </div>

            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/pages/TestPage.js